<template>
  <div>
    <card-component title="Evaluaciones" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" :header-search-input="false">
      <div slot="headerRight" class="card-header-icon">
        <div class="buttons">
            <b-button type="is-primary" @click="isDownloadModalActive = true" icon-left="file-excel">Datos CSV</b-button>
            <evaluation-table-filter @filtered="applyFilter"/>
        </div>
      </div>
      <b-table
        slot="content"
        :loading="isLoading"
        :paginated="paginated"
        :per-page="perPage"
        :striped="isStriped"
        :hoverable="hoverable"
        default-sort="name"
        :data="events"
      >
        <template slot-scope="props">
          <b-table-column label="Fecha" field="start_date">
            {{ moment(props.row.start_date, 'DD-MM-YYYY') | moment('LL')}}
          </b-table-column>
          <b-table-column label="Nombre" field="name">{{ props.row.name }}</b-table-column>
          <b-table-column label="Lugar" field="location.name">
            {{ props.row.location ? props.row.location.name : '-' }}
          </b-table-column>
          <b-table-column label="Hora de Inicio" field="start_at" centered>
            {{ moment(props.row.start_at, 'hh:mm') | moment('LT')}}
          </b-table-column>
          <b-table-column label="Binomios" field="executions_count" centered>
            <p>{{ props.row.executions_count }}</p>
          </b-table-column>
          <b-table-column label="Estado" field="status" centered>
            <status-tag :status="props.row.status.name"/>
          </b-table-column>
          <b-table-column custom-key="actions" class="is-actions-cell">
            <div class="buttons">
              <!--<b-button type="is-dark" size="is-small" @click="downloadSummary(props.row)" icon-right="download" :loading="isLoadingDownload && eventIdDownload === props.row.id">
              </b-button>-->
              <b-button type="is-success" size="is-small" @click="$emit('edit', props.row.id)">
                Editar
              </b-button>
              <router-link :to="{name:'evaluations.detail', params: {id: props.row.id}}" :class="['button is-small', props.row.status == 'Terminado' ? 'is-info':'is-primary']">
                {{ props.row.status.name == 'Terminado' ? 'Ver Nómina':'Ver Nómina'}}
              </router-link>
            </div>
          </b-table-column>
        </template>

        <section class="section" slot="empty">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>Cargando evaluaciones...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="horseshoe" size="is-large" />
              </p>
              <p>No hay evaluaciones en las fechas seleccionadas&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
    </card-component>
    <download-modal :active.sync="isDownloadModalActive" :start-date="startDate" :end-date="endDate"/>
  </div>
</template>

<script>
import StatusTag from './StatusTag.vue'
import EventService from '@/services/EventService.js'
import CardComponent from '@/components/CardComponent'
import EvaluationTableFilter from './EvaluationTableFilter'
import DownloadModal from './DownloadModal'

export default {
  components: {
    StatusTag,
    CardComponent,
    EvaluationTableFilter,
    DownloadModal
  },
  props: {
    reload: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  data () {
    const events = []
    return {
      events,
      paginated: true,
      perPage: 10,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
      isDownloadModalActive: false,
      filters: null,
      startDate: null,
      endDate: null,
      isLoadingDownload: false,
      eventIdDownload: null
    }
  },
  methods: {
    async downloadSummary (event) {
      this.isLoadingDownload = true
      this.eventIdDownload = event.id
      let params = {
        to: this.$moment(event.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
      let playload = await this.downloadEventSummary(event.id, params)
      let fileName = `Informe_de_resultados_${event.start_date}.pdf`
      this.generateFile(playload, fileName, 'application/pdf; charset=utf-8')
      this.openAlert()
      this.eventIdDownload = null
      this.isLoadingDownload = false
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    },
    async downloadEventSummary (eventId, params) {
      let response = await EventService.downloadEventSummary(eventId, params)
      return response.data
    },
    async generateFile (data, fileName, fileType) {
      var blob = new Blob([data], { type: fileType })
      var fileURL = window.URL.createObjectURL(blob)
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    applyFilter (data) {
      this.filters = data
      this.startDate = data.from ? this.$moment(data.from, 'YYYY-MM-DD').toDate() : null
      this.endDate = data.to ? this.$moment(data.to, 'YYYY-MM-DD').toDate() : null
      this.getEvents()
    },
    async getEvents () {
      this.isLoading = true
      let params = {
        'include[0]': 'status',
        'include[1]': 'location',
        'event_type_id': '1',
        ...this.filters
      }
      let response = await EventService.getEvents(params)
      this.events = response.data.data
      this.isLoading = false
    },
    sortByDate (a, b, isAsc) {
      if (isAsc) {
        return (
          new Date(b.start_date).getDate() - new Date(a.start_date).getDate()
        )
      } else {
        return (
          new Date(a.start_date).getDate() - new Date(b.start_date).getDate()
        )
      }
    }
  },
  watch: {
    reload (value) {
      if (value === true) {
        this.getEvents()
      }
      this.$emit('update:reload', false)
    }
  },
  computed: {
    subtitle () {
      let dataLenght = this.events.length
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} evento${plural} registrado${plural}`
    }
  }
}
</script>
